import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// Modules
import auth from "./store/auth.js";
import portalsettings from "./store/portalsettings.js";

export default new Vuex.Store({
  plugins: [createPersistedState({ key: "qgisitx-portal-settings" })],
  modules: {
    auth,
    portalsettings,
  },
});
